import styled from '@emotion/styled';
import { alpha } from '@mui/system';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';

type TagWrapperProps = {
  tagColor: string | null;
};

const TagWrapper = styled('li')<TagWrapperProps>(
  ({ theme }) => ({
    marginBottom: 12,
    marginLeft: 6,
    marginRight: 6,
    padding: 12,
    width: 'calc(50% - 12px)',
    boxSizing: 'border-box',
    overflowX: 'hidden',
    borderRadius: 4,
    display: 'inline-flex',
    alignItems: 'center',
    '.MuiIconButton-root': {
      transition: theme.transitions.create('all'),
    },
    ':not(:hover):not(:focus-within) .primary-controls-wrapper': {
      width: '100%',
    },
    ':not(:hover):not(:focus-within) .MuiIconButton-root': {
      marginRight: -30,
      opacity: 0,
    },
  }),
  ({ theme, tagColor }) => {
    if (tagColor === null) {
      return {
        border: `1px solid ${theme.palette.divider}`,
      };
    }

    return {
      color: alpha(theme.palette.getContrastText(tagColor), 0.9),
      backgroundColor: tagColor,
      border: `1px solid ${tagColor}`,
      '.MuiIconButton-root': {
        color: alpha(theme.palette.getContrastText(tagColor), 0.9),
      },
    };
  },
  addHighContrastStyles(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '.MuiIconButton-root': {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.background.paper,
    },
  })),
);

export default TagWrapper;
